// extracted by mini-css-extract-plugin
module.exports = {"dropup_wrapper":"MobileSize_dropup_wrapper__TPH12","size_guide":"MobileSize_size_guide__GGsgA"};